import type { ErrorInfo } from "react";

import { getBackend } from "./backend/Backend2";
import { getDatadogRum } from "./datadog/rumClient";

const MODULE = "app_error_boundary";

function formatMessage(error: Error, component_stack: string | undefined | null): string {
    const trimmed_stack = component_stack?.trim();
    const stack_suffix = trimmed_stack ? `\n${trimmed_stack}` : "";
    return `${error.message}${stack_suffix}`;
}

/**
 * Forwards React error-boundary catches to Datadog RUM (when initialized) and the backend
 * clientside-error API. Never throws — reporting must not break the fallback UI.
 */
export async function reportAppRenderError(error: Error, error_info: ErrorInfo): Promise<void> {
    try {
        const datadog_rum = await getDatadogRum();
        if (datadog_rum) {
            datadog_rum.addError(error, {
                source: MODULE,
                component_stack: error_info.componentStack,
            });
        }
    } catch (report_error) {
        console.error("Failed to report render error to Datadog RUM:", report_error);
    }

    try {
        await getBackend().tracking.logClientsideError({
            message: formatMessage(error, error_info.componentStack),
            module: MODULE,
            severity: "high",
        });
    } catch (report_error) {
        console.error("Failed to report render error to backend:", report_error);
    }
}
